import React from 'react';
import { ElementsConsumer } from '@stripe/react-stripe-js';
import { Stripe, StripeElements } from '@stripe/stripe-js';

export interface ElementsProps {
  elements: StripeElements | null;
  stripe: Stripe | null;
}

export default function withElements<P>(
  WrappedComponent: React.ComponentClass<P & ElementsProps>,
): React.ComponentClass<P> {
  return class extends React.Component<P> {
    render() {
      return (
        <ElementsConsumer>
          {({ elements, stripe }) => (
            <WrappedComponent
              elements={elements}
              stripe={stripe}
              {...this.props}
            />
          )}
        </ElementsConsumer>
      );
    }
  };
}
